export default __webpack_public_path__ + "static/media/Gauntlets of Untamed Violence.bf06778c.jpg";